import type { IClientRepository, ClientListQuery } from '@domain/data-contracts/client-repository.interface';
import type { Client } from '@domain/models/client.interface';
import type { PagedResult } from '@domain/models/paging.interface';

export class ClientsService {
  public constructor(private readonly repo: IClientRepository) {}

  public list(query: ClientListQuery): Promise<PagedResult<Client>> {
    return this.repo.list(query);
  }

  public getById(id: string): Promise<Client> {
    return this.repo.getById(id);
  }
}
